import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface PageContextType {
  pageTitle: string;
  setPageTitle: (title: string) => void;
  pageDescription?: string;
  setPageDescription: (description?: string) => void;
}

const PageContext = createContext<PageContextType | undefined>(undefined);

interface PageProviderProps {
  children: ReactNode;
}

export const PageProvider: React.FC<PageProviderProps> = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('Dashboard');
  const [pageDescription, setPageDescription] = useState<string | undefined>();

  const value = useMemo(() => ({
    pageTitle,
    setPageTitle,
    pageDescription,
    setPageDescription,
  }), [pageTitle, pageDescription]);

  return (
    <PageContext.Provider value={value}>
      {children}
    </PageContext.Provider>
  );
};

export const usePageContext = () => {
  const context = useContext(PageContext);
  if (context === undefined) {
    throw new Error('usePageContext must be used within a PageProvider');
  }
  return context;
};
